<style scoped>
    .game-list-item:not(.active)::before{
        content:"";
        display: block;
        background: rgba(0,0,0,.4);
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .game-list-item:hover::before{
        background: rgba(0,0,0,.2);
    }
    .text-3d>div{
        font-family:cursive;
        background-clip: text;
        -webkit-background-clip: text;
        grid-area: overlap;
        letter-spacing: 1px;
        -webkit-text-stroke: .2rem transparent;
    }
    .text-3d-bg{
        background-image: repeating-linear-gradient( 105deg, #ffb338 0% , #3e2904 5%, rgb(233, 233, 0) 12%);
        color: transparent;
        transform: scaleY(1.05);
        transform-origin: top;
    }
    .text-3d-fg{
        background-image: repeating-linear-gradient( 5deg, #ffb338 0% , #77571d 23%, yellow 31%);
        color: #2b3038;
        transform: scale(1);
    }
    .bg-gradient-both{
        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0),rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
    }
    .line{
        content: "";
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.3),rgba(255,255,255,0));
    }
    .game-item-hover:hover{
        background: linear-gradient(180deg,rgba(108,171,163,1) 0%,rgba(128,213,209,1) 20%, rgba(72,118,157,1) 100%);
    }
    .home-top{
        background: url(@/assets/images/home/homebg.jpg) no-repeat;
        background-size: 100% 100%;
        height: 40%;
    }
    .more-game{
        background: url(@/assets/images/home/homeleftbg.jpg) no-repeat 0 0/cover;
    }
    .logo{
        width: 100%;
        height: 23%;

    }
    .logo img{
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
        display: block;
    }
    .user-border{
        margin: 0 auto;
        border: 2px transparent solid;
        border-image: linear-gradient(45deg,#521104 0%,#F9E696 50%,#AD661A 100%) 1 10;
    }
    .user-text{
        margin: 2%;
        display: block;
        color: #FFF;
        background: #600000;
        font-size: .7em;
        border-radius: .2em;
        font-family: "黑体", SimHei, sans-serif !important;
        
    }
    .user-text>label{
        color: #fbfb00;
        font-family: "黑体", SimHei, sans-serif !important;
    }
    .navbar-type{
        width: 80%;
        height: 12%;
        margin-bottom: 1%;
        color: #4d3300;
        font-size: 1em;
        border-radius: .3em;
        background-image: linear-gradient(0deg,#bc9a50 0%,#fcfcd1 50%,#ad8328 100%);
        border:2px solid #4d3301;
        text-shadow: .06em .06em #e7e3b0;
    }
    .line-group{
        width: 94%;
        font-size: .5em;
    }
    .line-name{
        width: 80%;
        padding: 1%;
        border-radius: .2em;
        margin: 0 auto;
        background-image: linear-gradient(180deg,#666 0%,#C9C9C9 30%,#4c4c4c 60%);
        display: block;
        cursor: pointer;
        text-align: center;
    }
    .line-list{
        width: 80%;
        margin: 0 auto;
        background-color: #000;
        overflow: hidden;
    }
    .line-item{
        width: 100%;
        color: #fff;
        text-align: center;
        display: block;
        padding: 2% 0;
        cursor: pointer;
    }
    a{ 
        text-decoration:none;
    }
    a:hover { 
        text-decoration:none;
    }
    /* sir */
    .navbar-type{
        cursor: pointer;
    }
    .line-pagination{
        text-align: center;
        margin-bottom: 5%;
    }
    .line-page{
        border: .8em solid transparent;
        cursor: pointer;
        width: 0;
        border-top-width: .5em;
        border-bottom-width: .5em;
        display: inline-block;
        vertical-align: middle;
        line-height: 100%;
    }
    .line-left{
        border-left: 0;
        border-right-color: #c1791f;
    }
    .line-right{
        border-right: 0;
        border-left-color: #c1791f;
    }
    .line-pagination>span{
        background: #fff;
        margin: 0 15%;
        vertical-align: middle;
        display: inline-block;
    }
    .navbar-list{
        font-size: .7em;
    }
    .text-game{
        background: linear-gradient(90deg,#690205 0%,#CB2A0B 50%,#670104 100%);
        border-radius: 5px;
        border:1px solid #FC630B;
        font-family: "黑体", SimHei, sans-serif !important;
    }
    @media (max-width: 575px){
		.more-game{
            transform: translate(-100%,0);
            position: absolute;
        }
        .more-game.offset{
            animation: offset .25s cubic-bezier(.25, 1.15, .35, 1.08) forwards;
            background: rgba(0,0,0,.5);
        }
        .more-game-switch{
            transform: translate(100%,-100%);
        }
        /* .offset-room{
            animation: offset-room .25s cubic-bezier(.25, 1.15, .35, 1.08) forwards;
        } */
    }
    @keyframes offset {
        from {}
        to {
            /* position: relative; */
            transform: translate(0,0);
        }
    }
    /* @keyframes offset-room {
        from {}
        to {
            transform: translate(24%,0);
        }
    } */
</style>
<template>
    <div class="d-flex flex-column h-100">
        <div class="flex-grow-1 h-0">
            <div v-show="isShowMoreGame" class="position-fixed start-0 end-0 top-0 bottom-0 bg-black bg-opacity-50 index-1 d-sm-none"></div>
            <div class="d-flex flex-column h-100">
                <!-- <notice v-if="!isMultiple"></notice> -->
                <div class="home-top d-flex flex-column position-relative px-sm-0 pb-2">
                    <!-- 横向导航 -->
                    <navbar class="order-first" :has-chat-msg="hasChatMsg" :is-fullscreen="isFullscreen"></navbar>
                    
                    <div class="d-flex h-100 position-relative justify-content-start">
                        <!--游戏logo-->
                        <div class="d-flex h-100 flex-column flex-grow-11 align-items-center" style="width: 18%;">
                            <div class="d-flex flex-column pt-4">
                                <img class="img-fluid " src="logo.png">
                            </div>
                            <div class="userInfo w-100 my-2">
                                <div class="fs-4">
                                    <span class="user-border user-text px-2">账&nbsp;&nbsp;&nbsp;&nbsp;户：<label id="userID">{{userInfo.id}}</label></span>
                                    <span class="user-border user-text mt-1 px-2">真人余额：<label id="userID">{{userInfo.realCoin}}</label></span>
                                    <span class="user-border user-text mt-1 px-2">对战余额：<label id="userID" type="button" @click="$root.setCurrModal($t('home.moreGame'))">？</label></span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
                                <span class="p-2 px-3 fs-6 fw-bold text-light text-game" @click="$root.goPage('help',$root.callInfo,{id:userInfo.guid,name:userInfo.id,type:1,guid:guid})">联系我们</span>
                            </div>
                        </div>
                        <!-- 电话模式下显示的视频 -->
                        <div class="d-flex flex-column flex-sm-row w-83 h-100 pe-2_3rem mb-2" style="width: 81%;">
                            <media-video id="video1" class="rounded-3 overflow-hidden me-2 border border-3 border-warning" :video-index="0" :video-list="videoList" :room-class="['d-none']" :time-class="['d-none']" :img-class="['position-absolute translate-middle top-50 start-50']"></media-video>
                            <media-video id="video2" class="rounded-3 overflow-hidden border border-3 border-warning" :video-index="1" :video-list="videoList" :room-class="['d-none']" :time-class="['d-none']" :img-class="['position-absolute translate-middle top-50 start-50']"></media-video>
                        </div>
                    </div>
                </div>
                
                <!-- 主内容 -->
                <div class="d-flex flex-grow-1 position-relative px-sm-0">
                    
                    <!-- 游戏列表 -->
                    <div class="col-sm-2 d-flex flex-column more-game h-100 index-1 bg-gradient-both" :class="[isShowMoreGame?'offset':'']">
                        <div class="flex-grow-1 h-0 d-flex flex-column align-items-center">
                            <!-- <div class="logo d-flex flex-column justify-content-center">
                                <img class="img-fluid" src="logo.png">
                            </div> -->
                            
                            <div class="navbar-list text-center" style="width: 70%;">
                                <!-- <button class="navbar-type mb-2" type="button">{{currVideoLine!=""?this.videoLineList.find(v=>v.id==currVideoLine).name:""}}</button> -->
                                <div @click.stop="showLineList" class="position-relative d-flex justify-content-between align-items-center border border-dark rounded-3 p-2 mb-2 fs-6" style="box-shadow: 0 0 .15rem .08rem #000 inset; background: linear-gradient(0deg,#bc9a50 0%,#fcfcd1 50%,#ad8328 100%); font-family: '黑体', SimHei, sans-serif;">
                                    <span class="d-block border-end border-dark lh-1" style="width: 80%;">{{videoLineList.find(v=>v.id==currVideoLine)&&videoLineList.find(v=>v.id==currVideoLine).name}}</span>
                                    <i class="bi bi-caret-down-fill"></i>
                                    <div v-if="isShowLineList" class="position-absolute bg-black rounded-3 top-100 w-100 start-0 text-light d-flex flex-column pb-5">
                                        <span @click="$root.setCurrVideoLine(line.id)" v-for="line in videoLineList" :key="line">{{line.name}}</span>
                                    </div>
                                </div>
                                <!-- <button class="navbar-type mb-2" type="button" @click="showAgreement">协议条款</button>
                                <button class="navbar-type mb-2" type="button" @click="exitGame">离开游戏</button> -->
                                <div class="mb-2" type="button" @click="$root.setFullscreen">
                                    <img class="img-fluid start-0 w-100" src="@/assets/images/home/btn1_01.png">
                                </div>
                                <div class="mb-2" type="button" @click="showAgreement">
                                    <img class="img-fluid start-0 w-100" src="@/assets/images/home/btn2_01.png">
                                </div>
                                <div class="mb-2" type="button" @click="$root.setCurrModal($t('common.safeSetting'))">
                                    <img class="img-fluid start-0 w-100" src="@/assets/images/home/btn3_01.png">
                                </div>
                                <div class="mb-2" type="button" @click="$root.logout">
                                    <img class="img-fluid start-0 w-100" src="@/assets/images/home/btn4_01.png">
                                </div>
                                <div type="button" @click.stop="showLineList">
                                    <img class="img-fluid start-0 w-100" src="@/assets/images/home/btn5_01.png">
                                </div>
                            </div>
                            <div class="d-flex justify-content-evenly align-items-end mb-2 flex-grow-1">
                                <span class="p-2 px-3 fs-6 fw-bold text-light text-game" type="button" @click="$root.setCurrModal($t('personal.recharge'))">充值中心</span>
                                <span class="p-2 px-3 fs-6 fw-bold text-light text-game" type="button" @click="$root.goPage('help',$root.callInfo,{id:userInfo.guid,name:userInfo.id,type:1,guid:guid})">在线客服</span>
                            </div>
                            <!-- <div class="line-group pt-2">
                                <label @click="showLine" class="line-name py-1">{{videoLineList.name}}</label>
                                <div v-show="isShowLine" data-hidden="slide" class="line-list" >
                                    <div v-for="item in lineArr.slice(6*(currentLinePage-1),6*currentLinePage)" :key="item" @click="chooseLine(item.name,item.id)" class="line-item">{{item.name}}</div>
                                    <div class="line-pagination">
                                        <div @click="changeLinePage(-1)" class="line-page line-left"></div>
                                        <span><span>{{currentLinePage}}</span>/<span>{{Math.ceil(lineArr.length/6)}}</span></span>
                                        <div @click="changeLinePage(1)" class="line-page line-right"></div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <ul class="h-100 list-unstyled d-flex flex-column text-nowrap m-0 fw-bold text-cent
                             er overflow-y-scroll scroll-none">
                                <li v-for="item in gameList" :key="item" @click="getRoomList(item)" class="text-light game-item-hover" :class="[item==activeGame?'bg-cyan':'opacity-50']" role="button">
                                    <div class="py-3 px-3">{{$t("common."+GAME_CODE[item])}}</div>
                                    <div class="line"></div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                    
                    <!-- 台面列表 -->
                    <div :class="{'offset-room':isShowMoreGame}" class="flex-grow-1 h-100 d-flex flex-column">
                        <!-- 台面列表 -->
                        <div class="flex-grow-1 h-0">
                            <room-list :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj" @get-room-pearl="getRoomPearl" @on-ready="isRoomlistReady=true" :class="{'col-12 col-sm-6':$root.hasPearl(activeGame)}"></room-list>
                        </div>
                    
                    </div>
    
                </div>
            </div>
        </div>
        <foot-nav></foot-nav>
    </div>
</template>
<script>
import {COMMAND,GAME_ID,GAME_TYPE, RESULT,LAYER_TYPE,GAME_CODE, IS_DEBUG,USER,MUTATION_TYPE, GAME_MODEL} from "@/assets/js/config.js"
import navbar from "@/components/public/navbar.vue";
import roomList from '@/components/public/roomList.vue';
import footNav from '@/components/public/footNav.vue';
import mediaVideo from "@/components/public/video.vue";
import notice from '@/components/public/notice.vue';

export default {
    components: { navbar,roomList,footNav,mediaVideo,notice},
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            GAME_CODE,
            GAME_MODEL,
            countList:[],//路单统计列表
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            isShowMoreGame:false,//是否显示更多游戏
            isRoomlistReady:false,//台面列表组件是否加载完成
            videoList:[],//大厅视频线路地址，当前支持最多两个
            countdownWorkerList:[],//台面计时器webWorker对象列表
            searchInfo:{
                isCountdown:-1,//是否正在计时
                game:0,//游戏
                isAr:-1,//是否虚拟台
                pokerMode:-1,//开牌模式
            },//筛选信息
            // hideRoomidList:[],//要隐藏的台id
            isShowLineList:false,//是否显示线路列表
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        activeGame(){
            return this.$store.state.activeGame;
        },
        videoLineList(){
            return this.$store.state.videoLineList;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        gameList(){
            return this.$store.state.gameList;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        tabGame(){
            return this.$store.state.tabGame;
        }
    },
    mounted() {
        this.init();
        this.setWsMessage();//设置响应事件
    },
    unmounted(){
        delete this.$root.wsMsgObj["home"];
    },
    methods: {
        init(){
            //获取视频线路
            this.$emit('ws-send',COMMAND.all_getline,this.userInfo.id, this.userInfo.guid);
            //获取游戏列表
            !this.gameList&&this.$emit('ws-send', COMMAND.all_getgamelist, GAME_TYPE.all, this.userInfo.id, this.userInfo.guid);
            //获取用户信息
            this.$emit("ws-send",COMMAND.all_getuserinfo,this.userInfo.id, this.userInfo.guid);
            //获取台面列表（判断是否相等是防止相同游戏列表台返回厅时，重新加载列表但列表key绑定的是id，id不变所以不触发获取路，此举可减少获取和加载次数）
            if((!this.roomList)||(this.tabGame!=0&&this.activeGame!=this.tabGame)){
                this.$emit("ws-send",COMMAND.all_getroomlist, this.activeGame,this.userInfo.id, this.userInfo.guid);
            }
            this.$store.commit({
                type:MUTATION_TYPE.setBetRoomIdList,
                betRoomIdList:[]
            })
        },
        /**
         * 设置websocket响应事件
         */
        setWsMessage(){
            this.$root.wsMsgObj["home"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getgamelist:
                        this.$store.commit({
                            type:MUTATION_TYPE.setGameList,
                            gameList:data.game[GAME_TYPE.real].concat(data.game[GAME_TYPE.esports]).filter(v=>GAME_CODE[v])
                        })
                        break;
                    case COMMAND.all_getroompearl:
                        this.pearlObj={
                            id:data.id,
                            pearl:data.pearl
                        }
                        this.countList[data.id]=data.count;
                        break;
                    case COMMAND.all_entertable:
                        if(data.result==RESULT.enterTable.success){
                            this.$nextTick(()=>{
                                let room=this.roomList.find(v=>v.id==data.id);
                                if(room){
                                    this.$store.commit({
                                        type:MUTATION_TYPE.setRoomInfo,
                                        roomInfo:room
                                    })
                                    if(room.id==-2){
                                        this.$root.goPage("slotscroll");
                                    }else{
                                        this.$root.goPage(GAME_CODE[this.activeGame]);
                                    }
                                }
                            })
                        }
                        
                        break;
                    case COMMAND.all_refresh:
                    case COMMAND.bac_gameresult:
                    case COMMAND.cor_gameresult:
                    case COMMAND.dice_gameresult:
                    case COMMAND.rou_gameresult:
                        if(this.roomList){
                            typeof this.roomList.find(v=>v.id==data.id)!="undefined"&&this.getRoomPearl(this.activeGame,data.id,this.activeGame==GAME_ID.bac?200:this.$root.columnList[data.id]);//台面存在且可见
                        }
                        break;
                    case COMMAND.all_changeboot:
                        if(typeof this.roomList.find(v=>v.id==data.id)!="undefined"){//台面存在且可见
                            //清空路单
                            this.pearlObj={
                                id:data.id,
                                pearl:[]
                            }
                            //更新靴局
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomList,
                                room:{
                                    id:data.id,
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                            //更新统计
                            this.countList[data.id]=[0,0,0];
                        }
                        break;
                    case COMMAND.all_getline:
                        this.$store.commit({
                            type:MUTATION_TYPE.setVideoLineList,
                            videoLineList:data.list
                        })
                        let id=this.currVideoLine;//获取当前选中的视频线路
                        if(!id){//当前没有选中的视频线路，则设置默认线路
                            //由于大厅有视频，所以需要设置默认线路
                            this.$root.setCurrVideoLine(this.$root.getDefaultLineId(0),false);
                        }
                        //获取大厅视频
                        this.$emit("ws-send",COMMAND.all_getvideo,0,this.currVideoLine,this.userInfo.id,this.userInfo.guid);

                        break;
                    //电话模式处理
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                }
            }
        },
        /**
         * 显示更多游戏
         */
        showMoreGame(){
            this.isShowMoreGame=this.isShowMoreGame?false:true;
            if(this.isShowMoreGame){//显示状态下点击空白处隐藏
                document.onclick=(e)=>{
                    e.stopPropagation();
                    this.isShowMoreGame=false;
                }
            }
        },
        /**
         * 获取游戏对应台面列表
         */
        getRoomList(gameId){
            if(this.isRoomlistReady){//当页面内组件加载完成时才能再次获取，避免频繁获取
                this.isRoomlistReady=false;
                (!this.$root.changeGame(gameId,"activeGame"))&&(this.isRoomlistReady=true);//切换不成功需要把组件加载状态置回空闲，否则下次无法操作
            }
        },
        /**
         * 获取台面路单
         * @param {Number} tableId 台面id
         * @param {Number} column 获取的数据列数
         */
        getRoomPearl(gameId,tableId,column){
            this.activeGame==GAME_ID.bac&&(column=200);//bac路子有特殊性，所以不能根据列数取
            //获取台面路单
            this.$emit("ws-send",COMMAND.all_getroompearl, gameId,tableId,column,"list", this.userInfo.id, this.userInfo.guid);
        },
        showAgreement(){
            this.isShowAgreement?(this.isShowAgreement=false):(this.isShowAgreement=true);
        },
        showLineList(){
            this.isShowLineList=this.isShowLineList?false:true;
            if(this.isShowLineList){//显示状态下点击空白处隐藏
                document.onclick=(e)=>{
                    console.log("-----")

                    e.stopPropagation();
                    this.isShowLineList=false;
                }
            }
        }
    },
    watch: {
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal){
            if(this.gameModel==GAME_MODEL.tel){//电话模式
                if(newVal!=""){
                    //获取大厅视频
                    this.$emit("ws-send",COMMAND.all_getvideo,0,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                }else{
                    this.videoList=null;
                }
            }
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""){
                this.init();
            }
        },
        // searchInfo:{
        //     handler(newVal,oldVal){
        //         let arr=this.roomList.filter(v=>v.game!=this.searchInfo.game);
        //         if(arr&&arr.length>0){
        //             this.hideRoomidList=arr.map(v=>v.id);
        //         }
        //     },
        //     deep:true
        // }
    },
}
</script>